import { useAppUserSelector } from "@/store/reducers/appUser";

const useScheduleQueryPatientId = (patientId: string): string | undefined => {
  const { externalId: appUserId } = useAppUserSelector();
  return patientId === appUserId ? undefined : patientId;
};

export default useScheduleQueryPatientId;
